import { Button } from '@smartgift/frontend-toolkit';
import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import * as S from './style';

function ShowMore({
  container,
  children = [],
  numberOfLines = 3,
  type = 'text',
  seeLessLabel = 'See less',
  seeMoreLabel = 'See more',
  containerClassName = '',
  buttonColor
}) {
  const ContainerComponent = container || 'div';
  const [seeMore, setSeeMore] = useState(false);
  const [heights, setHeight] = useState({});
  const [showMoreContainerRef, setShowMoreContainerRef] = useState();

  const getChildren = () => {
    if (type === 'text') return children;
    if (children?.length <= numberOfLines) return children;
    return (!seeMore && children?.filter?.((v, index) => index < numberOfLines)) || children;
  };

  const toggleButton = () => {
    setSeeMore(!seeMore);
  };

  const getButton = () => {
    if (
      (type === 'array' && children.length > numberOfLines) ||
      heights.scrollHeight > heights.clientHeight
    ) {
      return (
        <Button variant="link" color={buttonColor} onClick={toggleButton}>
          {seeMore ? seeLessLabel : seeMoreLabel}
        </Button>
      );
    }
  };

  useEffect(() => {
    if (showMoreContainerRef) {
      setHeight({
        clientHeight: showMoreContainerRef.clientHeight,
        scrollHeight: showMoreContainerRef.scrollHeight
      });
    }
  }, [showMoreContainerRef]);

  return (
    <S.ShowMore numberOfLines={numberOfLines}>
      <ContainerComponent
        ref={setShowMoreContainerRef}
        className={cn({ 'show-more': !seeMore }, containerClassName)}
      >
        {type === 'array' ? getChildren() : children}
      </ContainerComponent>
      {getButton()}
    </S.ShowMore>
  );
}

ShowMore.propTypes = {
  children: PropTypes.array,
  numberOfLines: PropTypes.number,
  type: PropTypes.string,
  seeLessLabel: PropTypes.string,
  seeMoreLabel: PropTypes.string,
  containerClassName: PropTypes.string,
  buttonColor: PropTypes.string,
  container: PropTypes.node
};

export { ShowMore };
